import ExcelDownComponent from "@/pcomponents/common/excel/down";
import { useRef, forwardRef, useImperativeHandle } from 'react';
import strFunc from '@/lib/lyg/string';

const CustomListExcelDown = forwardRef((props: any, ref) => {
  let myProps = {
    infoArr: [],
    xColumnArr: {},
    ...props
  };
  const xColumnArr = myProps.xColumnArr;
  const ExcelDownComponentRef = useRef<any>();

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    goExcelDown
  }))

  const goExcelDown = (inData:any) => {
    let opt_obj={
      infoArr:myProps.infoArr,
      ...inData
    };
    if (ExcelDownComponentRef.current) {
      for (let i = 0; i < opt_obj.infoArr.length; i++) {
        let info = opt_obj.infoArr[i];
        info.row_view_sort1="";
        if(info.bsort1_title){
          info.row_view_sort1=info.bsort1_title;
        }
        info.row_view_sort2="";
        if(info.bsort2_title){
          info.row_view_sort2=info.bsort2_title;
        }
        info.row_view_sort3="";
        if(info.bsort3_title){
          info.row_view_sort3=info.bsort3_title;
        }
        info.row_view_stock_cnt="";
        if(info.product_info){
          info.row_view_stock_cnt=strFunc.comma(info.product_info.a_stock_cnt);
        }
        info.row_view_price=0;
        if(info.product_info){
          info.row_view_price=strFunc.uncomma_int(info.product_info.a_price);
          info.row_view_price+=strFunc.uncomma_int(info.product_info.a_price_tax);
          info.row_view_price=strFunc.comma(info.row_view_price);
        }
        info.row_view_price_use=0;
        if(info.product_info_use){
          info.row_view_price_use=strFunc.comma(info.product_info_use.a_price);
        }
      }

      ExcelDownComponentRef.current.setInitData({
        infoArr: opt_obj.infoArr
      });
      setTimeout(() => {
        ExcelDownComponentRef.current.goDownExcel();
      }, 100);
    }
  };

  return (
    <>
      <ExcelDownComponent
        ref={ExcelDownComponentRef}
        xColumnArr={xColumnArr}
        is_add_example={false}
      ></ExcelDownComponent>
    </>
  );
});
export default CustomListExcelDown;